/* i18n */
if(typeof window!=="undefined"&&typeof window.TR==="undefined"){window.TR=function(k,v){if(window.GS&&GS.t)return GS.t(k,v);if(window.GSUX_LANG&&window.GSUX_LANG[k]!=null)return window.GSUX_LANG[k];return k;};}
var TR=window.TR;
/*! GSLoading — make "Loading…" look like something is happening.
 *
 * Fifty plugins write their waiting state as plain text, under eight different class names:
 * vi2-empty, gm-vload, vh-tree-loading, ux-empty, tl-loading, uc-load and so on. Editing all of
 * them by hand would be fifty chances to get it wrong, and any plugin written next week would miss
 * out again. So this recognises the state rather than requiring each plugin to declare it: any
 * short leaf element whose text begins with Loading, Building, Fetching or similar gets an animated
 * bar, once, and loses it when the text changes to real content.
 *
 * Also exposed for new code, which should say so explicitly rather than rely on the sniffing:
 *   GSLoading.show(el, TR('js.fetching_the_page'))   GSLoading.hide(el)
 */
(function () {
  "use strict";
  var WORDS = /^(loading|building|fetching|searching|scanning|analysing|analyzing|working|please wait|one moment)\b/i;
  /* "Loading" / "Please wait" / "One moment" are always a state. The other words are also ordinary
     labels ("Searching the page" is the name of a problem), so they only count with an ellipsis. */
  var ALWAYS = /^(loading|please wait|one moment)\b/i;
  var DOTS = /(\u2026|\.\.\.)$/;
  function looksLoading(t) {
    return t.length > 0 && t.length < 60 && WORDS.test(t) && (ALWAYS.test(t) || DOTS.test(t));
  }
  var MARK  = "gsLoadingOn";
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  function isLoadingText(el) {
    /* Leaf elements only: a container whose descendants happen to contain the word is not itself
       a loading state, and decorating it would put a bar around half the page. */
    if (!el || el.nodeType !== 1 || el.children.length) return false;
    if (el.closest && el.closest("[data-no-loading]")) return false;
    return looksLoading((el.textContent || "").trim());
  }

  function decorate(el) {
    if (el.dataset[MARK]) return;
    el.dataset[MARK] = "1";
    el.classList.add("gs-loading");
    if (!reduce && !el.querySelector(".gs-loading-bar")) {
      var bar = document.createElement("span");
      bar.className = "gs-loading-bar";
      bar.setAttribute("aria-hidden", "true");
      el.appendChild(bar);
    }
    /* Screen readers get the state announced, which a spinner alone never does. */
    if (!el.getAttribute("role")) { el.setAttribute("role", "status"); el.setAttribute("aria-live", "polite"); }
  }

  function undecorate(el) {
    if (!el.dataset[MARK]) return;
    delete el.dataset[MARK];
    el.classList.remove("gs-loading");
    var b = el.querySelector(".gs-loading-bar");
    if (b) b.remove();
    el.removeAttribute("aria-live");
  }

  function sweep(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes;
    try { nodes = scope.querySelectorAll("div,p,span,td,li,section"); }
    catch (e) { return; }
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      /* The bar itself is a child, so a decorated element is no longer a leaf — check the flag
         first or it would immediately un-decorate itself. */
      if (el.dataset && el.dataset[MARK]) {
        var txt = (el.textContent || "").trim();
        if (!looksLoading(txt)) undecorate(el);
        continue;
      }
      if (isLoadingText(el)) decorate(el);
    }
  }

  /* Debounced: plugins repaint whole panels at once, and running on every mutation would mean
     hundreds of sweeps for one render. */
  var pending = null;
  function schedule(target) {
    if (pending) return;
    pending = setTimeout(function () { pending = null; sweep(target || document); }, 60);
  }

  function start() {
    var main = document.querySelector(".gs-main") || document.body;
    sweep(main);
    if (!window.MutationObserver) return;
    new MutationObserver(function () { schedule(main); })
      .observe(main, { childList: true, subtree: true, characterData: true });
  }

  window.GSLoading = {
    show: function (el, msg) {
      if (!el) return;
      if (msg) el.textContent = msg;
      else if (!isLoadingText(el)) el.textContent = "Loading\u2026";
      decorate(el);
    },
    hide: function (el) { if (el) undecorate(el); },
    sweep: sweep
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
